"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboBox = void 0;
var Algemeen = require("./Algemeen");
function ComboBox($tb, $pnl, filterAndFill, textboxValueOnBlur, classItem, classItemInFocus) {
    var _self = this;
    this.$tb = $tb;
    this.$pnl = $pnl;
    this.DisableKeyUp = false;
    this.$tb.keyup(function (e) { tbOnkeyup(e); });
    this.$tb.keydown(function (e) { tbOnkeydown(e); });
    this.$tb.focus(function () { tbOnfocus(); });
    this.$tb.blur(function () { console.log("tbOnBlur"); tbOnblur(); });
    this.$pnl.mousedown(function () { pnlOnmousedown(); });
    this.selectedValue = '';
    this.classItem = classItem;
    this.classItemInFocus = classItemInFocus;
    function tbOnkeyup(e) {
        if (!_self.DisableKeyUp) {
            if (filterAndFill != undefined) {
                filterAndFill(_self);
                _self.$tb.blur(function () { tbOnblur(); });
            }
        }
    }
    function tbOnkeydown(e) {
        Algemeen.KeyDown(e, _self);
    }
    function tbOnfocus() {
        console.log("tbOnfocus");
        if (filterAndFill != undefined) {
            filterAndFill(_self);
            console.log("filterAndFill");
        }
    }
    function tbOnblur() {
        var Item = textboxValueOnBlur(_self.$tb.val());
        if (Item.hasOwnProperty('Code')) {
            _self.$tb.val(Item.Description);
            _self.selectedValue = Item.Code;
        }
        else {
            _self.$tb.val(Item);
        }
        _self.hidePopup();
    }
    function pnlOnmousedown() {
        _self.$tb.off('blur');
    }
    this.pnlOnMouseover = function (div) {
        _self.$pnl.find('.' + classItemInFocus).removeClass(classItemInFocus);
        $(div).addClass(classItemInFocus);
    };
    this.pnlOnClick = function (Code, Description) {
        _self.hidePopup();
        _self.$tb.val(Description);
        _self.selectedValue = Code;
    };
}
exports.ComboBox = ComboBox;
ComboBox.prototype.showPopup = function () {
    this.$pnl.css('left', this.$tb.position().left);
    this.$pnl.css('top', this.$tb.position().top + this.$tb.outerHeight());
    this.$pnl.css('visibility', 'visible');
};
ComboBox.prototype.hidePopup = function () {
    this.$pnl.css('visibility', 'hidden');
};
ComboBox.prototype.CItem = function () {
    this.Code = '';
    this.Description = '';
};
